import { useAuthContext } from '@/context/AuthContext'

export function useSession() {
  return useAuthContext().session
}

export function useUser() {
  return useAuthContext().user
}

export function useIsAuthLoading() {
  return useAuthContext().isLoading
}
